import {
  showHideRequirements,
  hideCheckboxRequired,
  isStandardFieldMissing,
  removeRequiredDisplay,
  setMobile,
  initRequiredElements,
  initCloseButton,
  isFormValid,
} from './registration-screen';

import { allCountryCodes } from './allCountryCodes';

const variants = ['Biometrics', 'Windows Hello', 'Face ID', 'Touch ID'];

function postDisconnect(id) {
  if (variants.indexOf(id) >= 0) id = 'FIDO';
  document.forms[0]['pf.disconnect.identity'].value = id;
  document.forms[0].submit();
}

function postConnect(id) {
  if (variants.indexOf(id) >= 0) id = 'FIDO';
  document.forms[0]['pf.connect.identity'].value = id;
  document.forms[0].submit();
}

function postSendEmailVerification() {
  document.forms[0]['pf.send.email.verify'].value = 'clicked';
  document.forms[0].submit();
}

function formatDateOfBirth() {
  const yyyyMMdd = document.getElementById('lipvDateOfBirth').value;
  document.getElementById('formatted-lipvDateOfBirth').value = toDisplayDate(yyyyMMdd);
}

function toDisplayDate(yyyyMMdd = '') {
  if (yyyyMMdd === '' || yyyyMMdd.length !== 8) {
    return '';
  }
  const yyyy = yyyyMMdd.substring(0, 4);
  const MM = yyyyMMdd.substring(4, 6);
  const dd = yyyyMMdd.substring(6, 8);
  return `${dd}/${MM}/${yyyy}`;
}

function postSave() {
  if (!isFormValid()) {
    return false;
  }

  // run browser validation
  if (
    document.forms[0].checkValidity &&
    !document.forms[0].checkValidity() &&
    document.forms[0].reportValidity
  ) {
    document.forms[0].reportValidity();
    return false;
  }

  if (
    document.lipPersonalMobile !== document.forms[0].lipPersonalMobile.value &&
    document.forms[0].lipPersonalMobile.value !== ''
  ) {
    setLocalData('perschanged', 'true');
  }
  if (
    document.lipBusinessMobile !== document.forms[0].lipBusinessMobile.value &&
    document.forms[0].lipBusinessMobile.value !== ''
  ) {
    setLocalData('buschanged', 'true');
  }
  if (
    document.lipPersonalEmail !== document.forms[0].lipPersonalEmail.value &&
    document.forms[0].lipPersonalEmail.value !== ''
  ) {
    setLocalData('persEmailchanged', 'true');
  }
  if (
    document.lipBusinessMail !== document.forms[0].lipBusinessMail.value &&
    document.forms[0].lipBusinessMail.value !== ''
  ) {
    setLocalData('busEmailchanged', 'true');
  }

  document.forms[0]['pf.save'].value = 'clicked';
  document.forms[0].submit();
  return true;
}

function revealPassword() {
  const input = document.getElementById('password');
  const elemReveal = document.getElementById('reveal');
  if (input.type === 'password') {
    input.setAttribute('type', 'text');
    elemReveal.className = 'password-show-button icon-view-hidden';
  } else {
    input.setAttribute('type', 'password');
    elemReveal.className = 'password-show-button icon-view';
  }
}

function postChangePass() {
  const currPass = document.getElementById('currentPassword');
  const newPass = document.getElementById('password');

  if (isStandardFieldMissing(currPass) || isStandardFieldMissing(newPass)) {
    document.getElementById('required-password-field-error').style.display = 'block';
    return false;
  }

  document.forms[0]['pf.change.pass'].value = 'clicked';
  document.forms[0].submit();
  return true;
}

function postSetPass() {
  const newPass = document.getElementById('password');

  if (isStandardFieldMissing(newPass)) {
    document.getElementById('required-password-field-error').style.display = 'block';
    return false;
  }

  document.forms[0]['pf.set.pass'].value = 'clicked';
  document.forms[0].submit();
  return true;
}

function postDelete() {
  document.forms[0]['pf.delete'].value = 'clicked';
  document.forms[0].submit();
}

function postLogout() {
  document.forms[0]['pf.logout'].value = 'clicked';
  document.forms[0].submit();
}

function postChangePassOnReturn(e) {
  removeRequiredDisplay(e);

  let keycode;
  if (window.event) keycode = window.event.keyCode;
  else if (e) keycode = e.which;
  else return true;

  if (keycode === 13) {
    postChangePass();
    return false;
  }
  return true;
}

function postSetPassOnReturn(e) {
  removeRequiredDisplay(e);

  let keycode;
  if (window.event) keycode = window.event.keyCode;
  else if (e) keycode = e.which;
  else return true;

  if (keycode === 13) {
    postSetPass();
    return false;
  }
  return true;
}

function postOnReturn(e) {
  let keycode;
  if (window.event) keycode = window.event.keyCode;
  else if (e) keycode = e.which;
  else return true;

  if (keycode === 13) {
    postSave();
    return false;
  }
  return true;
}

function hideTooltip() {
  const tooltips = document.getElementsByClassName('details-tooltip');
  for (let i = 0; i < tooltips.length; i += 1) {
    tooltips[i].className = tooltips[i].className.replace('show', '');
  }
}

function showTooltip(element) {
  hideTooltip();
  element.parentElement.className += ' show';
}

function setNarrow(narrow) {
  const bodyTag = document.getElementsByTagName('body')[0];
  const className = ' narrow';
  const hasClass = bodyTag.className.indexOf(className) !== -1;

  if (narrow && !hasClass) {
    bodyTag.className += className;
  } else if (!narrow && hasClass) {
    bodyTag.className = bodyTag.className.replace(className, '');
  }
}

function getScreenWidth() {
  return window.outerHeight ? window.outerWidth : document.body.clientWidth;
}

/// ///////////////////////////////////////////////////////////////////////////////////////////////
// Start of unscoped code

function init() {
  let width = getScreenWidth();
  let userAgent = '';
  if (navigator.userAgent.toLowerCase().match(/android/i)) {
    userAgent = ' device-android';
  }
  if (
    /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  ) {
    setMobile(true, userAgent);
  } else {
    setMobile(width <= 480, userAgent);
    setNarrow(width <= 900);
    window.onresize = () => {
      width = getScreenWidth();
      setMobile(width <= 480, userAgent);
      setNarrow(width <= 900);
    };
  }

  // check width for details tooltips (300px w)
  function getTooltipSizing(mobile) {
    const tooltips = document.getElementsByClassName('details-content');
    // divide by 4 instead of 2 to account for marginLeft of 36px
    const leftPosition = `left: ${(width - 300) / 4}px`;
    const narrow = width <= 900;
    for (let i = 0; i < tooltips.length; i += 1) {
      if (mobile || narrow) {
        tooltips[i].style.cssText = leftPosition;
      } else {
        tooltips[i].style.cssText = '';
      }
    }
  }

  // if (width <= 480) {
  if (width <= 900) {
    getTooltipSizing(true);
    window.onresize = () => {
      width = getScreenWidth();
      // getTooltipSizing(width <= 480);
      getTooltipSizing(width <= 900);
    };
  }

  if (document.getElementById('profile-password-message')) {
    if (/iPhone|iPod/i.test(navigator.userAgent)) {
      const tooltip = document.getElementById('change-password-tooltip');
      tooltip.scrollIntoView();
    } else {
      document.getElementById('currentPassword').focus();
    }
  }

  initRequiredElements(
    document.forms[0].querySelectorAll('.required-missing-display,.pass-required')
  );
}

function clearMessage(element, timeout) {
  setTimeout(() => {
    element.style.display = 'none';
  }, timeout);
}

function showMessage(element, timeout) {
  setTimeout(() => {
    element.style.display = 'block';
  }, timeout);
}

function focusCurrentPasswordField() {
  document.getElementById('currentPassword').focus();
}

function focusNewPasswordField() {
  document.getElementById('password').focus();
}

/// ///////////////////////////////////////////////////////////////////////////////////////////////
// More unscoped code
function init2() {
  const messages = document.querySelectorAll('.page-messages .message');
  for (let i = 0; i < messages.length; i += 1) {
    showMessage(messages[i], 250 * i);
  }

  // hide messages after 15 seconds.
  setInterval(() => {
    for (let i = 0; i < messages.length; i += 1) {
      clearMessage(messages[i], 750 * i);
    }
  }, 15000);

  initCloseButton();

  if (document.getElementById('icon-email-verification')) {
    // attach hover event to email verification
    const emailVerification = document.getElementById('icon-email-verification');
    emailVerification.addEventListener(
      'mouseover',
      (event) => {
        document.getElementById('email-verification-text').className =
          'confirmation-text show';
        // reset the class after 3 seconds
        setTimeout(() => {
          document.getElementById('email-verification-text').className =
            'confirmation-text';
        }, 3000);
      },
      false
    );
  }
}

function doOTC(type) {
  //    	const urlParams = new URLSearchParams(window.location.search);
  //    	const tr = encodeURIComponent(urlParams.get('TargetResource'));
  const base = document.getElementsByTagName('base')[0].href;
  const tr = encodeURIComponent(`${base}pf/idprofile.ping`); // const tr = "https%3A%2F%2Frhciamalvd1.mid.aib.pri%3A9031%2Fpf%2Fidprofile.ping"
  window.location.href = `/sp/startSSO.ping?TargetResource=${tr}&SpSessionAuthnAdapterId=idprofileaibuseridentityprofile1&LocalIdentityProfileID=aibuseridentityprofile1&otc=${type}`;
}

function doReturn() {
  window.location.href = getFromQueryOrLocal('returnTo');
}

function populateCountryCodeOptions(elemId = 'mobileCountryCode') {
  const selectElem = document.getElementById(elemId);
  for (let i = 0; i < allCountryCodes.length; i += 1) {
    const [currentCountryCode, countryName] = allCountryCodes[i];
    const countryElement = document.createElement('option');
    countryElement.textContent = `+${currentCountryCode} ${countryName}`;
    countryElement.value = currentCountryCode;
    selectElem.appendChild(countryElement);
  }
}

function onLoad(success) {
  init();
  init2();
  populateCountryCodeOptions('countryCode_lipPersonalMobile');
  populateCountryCodeOptions('countryCode_lipBusinessMobile');
  formatDateOfBirth();

  const supportedOTCTypes = ['pers', 'bus', 'persEmail', 'busEmail'];

  const doVerify = getFromQueryOrLocal('doVerify');

  if (doVerify) {
    eraseLocalData('doVerify');
    // doVerify will be one of:
    // pers, bus, persEmail, busEmail

    if (supportedOTCTypes.includes(doVerify)) {
      eraseLocalData(`${doVerify}changed`);
      doOTC(doVerify);
      return;
    }
  }

  const returnTo = getFromQueryOrLocal('returnTo');

  if (returnTo) {
    setLocalData('returnTo', returnTo);
  }

  if (!returnTo) {
    document.getElementById('returnbtn').style.display = 'none';
  }

  // Native apps, like the AuthApp have a different logout process so we hide the button
  const showLogout = getFromQueryOrLocal('showLogout') || 'true';

  if (showLogout) {
    setLocalData('showLogout', showLogout);
  }

  // Defaults to visible, so only hide if explicitly asked to.
  // Will remain visible for GroupWebsites
  if (showLogout === 'false') {
    document.getElementById('logout-button').style.display = 'none';
  }

  document.lipPersonalMobile = document.forms[0].lipPersonalMobile.value;
  document.lipBusinessMobile = document.forms[0].lipBusinessMobile.value;
  document.lipPersonalEmail = document.forms[0].lipPersonalEmail.value;
  document.lipBusinessMail = document.forms[0].lipBusinessMail.value;

  // check if any of the supported OTC fields have changed
  // if so send the OTC & prompt for verifiction
  supportedOTCTypes.forEach((otctype) => {
    if (getLocalData(`${otctype}changed`) === 'true') {
      // console.log( "found " + otctype + "changed Data === true")
      eraseLocalData(`${otctype}changed`);
      if (success) {
        doOTC(otctype);
      }
    }
  });
}

function setLocalData(name, value, days) {
  window.sessionStorage.setItem(name, value);
}
function getLocalData(name) {
  return window.sessionStorage.getItem(name);
}

function readFromCookie(name) {
  const nameEQ = `${name}=`;
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
}

function eraseLocalData(name) {
  window.sessionStorage.removeItem(name);
}

function getFromQueryOrLocal(name) {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name) || getLocalData(name) || readFromCookie(name);
}

function onClickEditMobile(event) {
  const hiddenInputId = event.srcElement.id.split('_')[1];
  document.getElementById(`phoneNumberReadModeContainer_${hiddenInputId}`).style.display =
    'none';
  document.getElementById(`phoneNumberEditModeContainer_${hiddenInputId}`).style.display =
    'block';

  event.preventDefault();
  return false;
}

// Setup the aib namespace
const localWindow = window || {};
localWindow.aib = localWindow.aib || {};
const { aib } = localWindow;
aib.profile = {
  ...aib.profile,
  onLoad,
  doOTC,
  postOnReturn,
  showTooltip,
  focusCurrentPasswordField,
  hideTooltip,
  revealPassword,
  postChangePassOnReturn,
  postChangePass,
  postLogout,
  doReturn,
  postSave,
  postSendEmailVerification,
  hideCheckboxRequired,
  postDisconnect,
  postConnect,
  showHideRequirements,
  focusNewPasswordField,
  postSetPassOnReturn,
  postSetPass,
  postDelete,
  onClickEditMobile,
  readFromCookie,
};
